import React from 'react';
import {
  Box,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Stack,
  Typography,
  Slider,
  Divider,
} from '@mui/material';

const ProgramFilters = ({
  filters,
  onFilterChange,
  onClearFilters,
  filteredCount,
  totalCount,
  filterOptions
}) => {
  const handleFilterChange = (filterType, value) => {
    onFilterChange({ ...filters, [filterType]: value });
  };

  const handleTuitionRangeChange = (event, newValue) => {
    onFilterChange({ ...filters, tuitionRange: newValue });
  };

  const getActiveFiltersCount = () => {
    let count = 0;
    if (filters.level) count++;
    if (filters.duration) count++;
    if (filters.intake) count++;
    if (filters.tuitionRange && (filters.tuitionRange[0] > 0 || filters.tuitionRange[1] < 1000000)) count++;
    return count;
  };

  const activeFiltersCount = getActiveFiltersCount();

  // 确保有默认的筛选选项
  const safeFilterOptions = {
    levels: filterOptions?.levels || [],
    durations: filterOptions?.durations || [],
    intakes: filterOptions?.intakes || []
  };

  return (
    <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          筛选专业
        </Typography>
        {activeFiltersCount > 0 && (
          <Chip
            label={`${activeFiltersCount} 个筛选条件`}
            variant="outlined"
            color="primary"
            size="small"
            onDelete={onClearFilters}
          />
        )}
      </Box>

      {filteredCount !== undefined && totalCount !== undefined && (
        <Box sx={{ mb: 3 }}>
          <Typography variant="body2" color="text.secondary">
            本页显示 <strong>{filteredCount}</strong> 个，共 <strong>{totalCount}</strong> 个专业
          </Typography>
        </Box>
      )}

      <Stack spacing={3}>
        {/* 学位级别 */}
        <FormControl fullWidth size="small">
          <InputLabel>学位级别</InputLabel>
          <Select
            value={filters.level || ''}
            label="学位级别"
            onChange={(e) => handleFilterChange('level', e.target.value)}
          >
            {safeFilterOptions.levels.map((level) => (
              <MenuItem key={level.value} value={level.value}>
                {level.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* 学制 */}
        <FormControl fullWidth size="small">
          <InputLabel>学制</InputLabel>
          <Select
            value={filters.duration || ''}
            label="学制"
            onChange={(e) => handleFilterChange('duration', e.target.value)}
          >
            {safeFilterOptions.durations.map((duration) => (
              <MenuItem key={duration.value} value={duration.value}>
                {duration.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* 入学时间 */}
        <FormControl fullWidth size="small">
          <InputLabel>入学时间</InputLabel>
          <Select
            value={filters.intake || ''}
            label="入学时间"
            onChange={(e) => handleFilterChange('intake', e.target.value)}
          >
            {safeFilterOptions.intakes.map((intake) => (
              <MenuItem key={intake.value} value={intake.value}>
                {intake.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Divider />

        {/* 学费范围 */}
        <Box>
          <Typography variant="body2" sx={{ mb: 2, fontWeight: 500 }}>
            学费范围 (马币)
          </Typography>
          <Box sx={{ px: 1 }}>
            <Slider
              value={filters.tuitionRange || [0, 1000000]}
              onChange={handleTuitionRangeChange}
              valueLabelDisplay="auto"
              valueLabelFormat={(value) => typeof value === 'number' ? value.toLocaleString() : value || '0'}
              min={0}
              max={1000000}
              step={10000}
              marks={[
                { value: 0, label: '0' },
                { value: 200000, label: '200K' },
                { value: 400000, label: '400K' },
                { value: 600000, label: '600K' },
                { value: 800000, label: '800K' },
                { value: 1000000, label: '1000K' }
              ]}
              sx={{
                '& .MuiSlider-thumb': {
                  height: 20,
                  width: 20,
                },
                '& .MuiSlider-track': {
                  height: 4,
                },
                '& .MuiSlider-rail': {
                  height: 4,
                }
              }}
            />
          </Box>
        </Box>

        {/* 清除筛选 */}
        {activeFiltersCount > 0 && (
          <Box sx={{ pt: 2 }}>
            <Typography
              variant="body2"
              sx={{ 
                color: 'primary.main', 
                cursor: 'pointer',
                textDecoration: 'underline',
                '&:hover': {
                  color: 'primary.dark'
                }
              }}
              onClick={onClearFilters}
            >
              清除所有筛选条件
            </Typography>
          </Box>
        )}
      </Stack>
    </Paper>
  );
};

export default ProgramFilters;
